/**
 * The app/platform codes that carry a Mobeyond brand name.
 *
 * A branding-only type, deliberately separate from `PlatformName` (access rights) and the
 * `UserInfoCookieAppName` enum (auth identity): branding is its own concern, and reusing either
 * would drag an unrelated contract along — `UserInfoCookieAppName`'s `MRT_FR = 'MRT'` value
 * collision would silently drop a key.
 */
export type BrandCode =
  | 'MGT'
  | 'FMS'
  | 'ORD'
  | 'MRT'
  | 'MRT_FR'
  | 'REI'
  | 'DIVC'
  | 'MOBICLEAR'
  | 'ORD_ADMIN'
  | 'PRE_ORD';

/**
 * The single source of the Mobeyond display names — read from code, never from the translation
 * system, because these are language-invariant branding identities rather than business data.
 *
 * Strict `Record<BrandCode, string>` on purpose: the compiler proves the set is complete, so a
 * forgotten code fails the build instead of rendering blank.
 */
export const BRAND_NAMES: Record<BrandCode, string> = {
  MGT: 'Mobiview',
  FMS: 'Mobifines',
  ORD: 'Mobiorder',
  MRT: 'Mobitech',
  MRT_FR: 'Mobitech',
  REI: 'Mobipay',
  DIVC: 'MobiDIV',
  MOBICLEAR: 'Mobiclear',
  ORD_ADMIN: 'Mobiorder Admin',
  PRE_ORD: 'Mobiquote'
};
